export function hasBruker(fileCollection) {
    return fileCollection.files.some((file) => ['2rr', 'fid', '1r'].some((brukerFile) => file.name.endsWith(brukerFile)));
}
//# sourceMappingURL=hasBruker.js.map